import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "@mui/material";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import EligibleTable from "./EligibleTable";
import { getEligibleStudents } from "../../../redux/features/careerSlice";

// Students who can apply to ONE job (reached by a job row's "Can Apply" button).
const EligibleStudents = () => {
  const { jobId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { eligibleStudents, loading } = useSelector((state) => state.career);

  useEffect(() => {
    dispatch(getEligibleStudents(jobId));
  }, [dispatch, jobId]);

  return (
    <GlobalWrapper
      title={"Students Who Can Apply"}
      actions={
        <Button variant="outlined" size="small" onClick={() => navigate("/career-connect/jobs")}>
          Back to Jobs
        </Button>
      }
    >
      <EligibleTable rows={eligibleStudents?.data || []} loading={loading} />
    </GlobalWrapper>
  );
};

export default EligibleStudents;
